module.exports = __webpack_public_path__ + "static/media/TheBride.78601b04.jpg";